/*
 * ar-product-grid.js
 * SP/PC で表示件数を切り替える（settings の limit_mobile / limit_pc に応じて）。
 * Liquid 側で limit には max(SP, PC) を渡し、JS で SP/PC ごとに切り捨て表示。
 */
(function () {
  function init(root) {
    if (root.dataset.arPgInit === 'true') return;
    root.dataset.arPgInit = 'true';

    const items = root.querySelectorAll('[data-ar-pg-item]');
    if (!items.length) return;

    const limitMobile = parseInt(root.dataset.limitMobile, 10) || 6;
    const limitPc = parseInt(root.dataset.limitPc, 10) || 8;
    const mq = window.matchMedia('(min-width: 750px)');

    function apply() {
      const limit = mq.matches ? limitPc : limitMobile;
      items.forEach(function (item, i) {
        item.style.display = i >= limit ? 'none' : '';
      });
    }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  function initAll() {
    document.querySelectorAll('[data-ar-pg]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    const root = e.target.querySelector('[data-ar-pg]');
    if (root) {
      root.dataset.arPgInit = 'false';
      init(root);
    }
  });
})();
